import classNames from 'classnames';

const getDynamicTitleClasses = isWideMedia => {
    return classNames({
        'text-center': true,
        'text-wrapper': true,
        'col-md-10': isWideMedia,
        'offset-md-1': isWideMedia,
        'col-md-6': !isWideMedia,
        'text-left': !isWideMedia,
    });
};

export default getDynamicTitleClasses